import { useCallback as e } from "react";
import { useTranslation as t } from "react-i18next";
import { CheckoutReasonCode as n } from "@maat/api-booking/types";
//#region src/enums/useTrIdentityCheckoutAction.ts
var r = () => {
	let { t: r } = t("booking");
	return e((e) => {
		switch (e?.code) {
			case n.IdentityNotVerified: return r("checkout.identity.actions.verify");
			case n.IdentityVerificationPending: return r("checkout.identity.actions.viewStatus");
			case n.IdentityVerificationRejected: return r("checkout.identity.actions.retry");
			default: return;
		}
	}, [r]);
};
//#endregion
export { r as useTrIdentityCheckoutAction };
